<template>
    <div>
        <component-header
            title="Create Tenant"
            :hasSearch="false"
            :hasReload="false"
            :hasCreate="false"
            :hasback="true"
            @back-press="$router.push('/tenant')"
        />
        <section class="section-b-space">
            <b-row>
                <b-col class="p-0">
                    <div class="my-2 mb-4 ml-4 mr-2">
                        <v-stepper alt-labels v-model="e1">
                            <v-stepper-header class="text-nowrap overflow-auto">
                            <v-stepper-step
                                step="1"
                                class="v-stepper-step-outline ml-2"
                                >Basic Info</v-stepper-step
                            >
                            <v-divider />
                            <v-stepper-step
                                step="2"
                                class="v-stepper-step-outline"
                            >
                                Authentication
                            </v-stepper-step>
                            <v-divider />
                            <v-stepper-step
                                step="3"
                                class="v-stepper-step-outline mr-1"
                                >Business Plan</v-stepper-step
                            >
                            <v-divider />
                            <v-stepper-step
                                step="4"
                                class="v-stepper-step-outline mr-2"
                                >Theme</v-stepper-step
                            >
                            <v-divider />
                            <v-stepper-step
                                step="5"
                                class="v-stepper-step-outline ml-1"
                                >KYC</v-stepper-step
                            >
                            <v-divider />
                            <v-stepper-step
                                step="6"
                                class="v-stepper-step-outline ml-1"
                                >DONE
                            </v-stepper-step>
                            </v-stepper-header>

                            <v-stepper-items>
                            <v-stepper-content step="1">
                                <basicInfoVue
                                    @place_changed="setPlace"
                                    ref="basicInfo"
                                    @isValid="(val) => (basicInfoValid = val)"
                                >
                                    <template v-slot:footer-button="data">
                                        <div class="text-center">
                                            <span
                                                class="text-danger font-weight-bold"
                                                >{{ error }}</span
                                            >
                                        </div>
                                        <div class="text-center">
                                            <b-button
                                                variant="primary"
                                                class="next-btn"
                                                @click="
                                                    basicInfoToNext(data.data)
                                                "
                                                >CONTINUE TO AUTHENTICATION
                                            </b-button>
                                        </div>
                                    </template>
                                </basicInfoVue>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <s-authentication ref="authRef">
                                    <template v-slot:footer-button="data">
                                        <div class="text-center">
                                            <span
                                                class="text-danger font-weight-bold"
                                                >{{ error }}</span
                                            >
                                        </div>
                                        <b-row class="mt-4 footer-buttons-row">
                                            <b-col
                                                cols="12"
                                                md="6"
                                                class="text-center text-md-right mb-2 mb-md-0"
                                            >
                                                <b-button
                                                    variant="outline-primary"
                                                    @click="e1 = 1"
                                                    class="cancel-btn"
                                                    >GO BACK TO BASIC
                                                    INFO</b-button
                                                >
                                            </b-col>
                                            <b-col
                                                cols="12"
                                                md="6"
                                                class="text-center text-md-left"
                                            >
                                                <b-button
                                                    variant="primary"
                                                    class="next-btn"
                                                    @click="
                                                        authenticationToNext(
                                                            data.data,
                                                        )
                                                    "
                                                    >CONTINUE TO BUSINESS
                                                    PLAN</b-button
                                                >
                                            </b-col>
                                        </b-row>
                                    </template>
                                </s-authentication>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <businessPlanVue ref="businessPlanRef">
                                    <template v-slot:footer-button="data">
                                        <div class="text-center">
                                            <span
                                                class="text-danger font-weight-bold"
                                                >{{ error }}</span
                                            >
                                        </div>
                                        <b-row class="mt-4 footer-buttons-row">
                                            <b-col
                                                cols="12"
                                                md="6"
                                                class="text-right mb-2 mb-md-0"
                                            >
                                                <b-button
                                                    variant="outline-primary"
                                                    @click="e1 = 2"
                                                    class="cancel-btn"
                                                    >GO BACK TO
                                                    AUTHENTICATION</b-button
                                                >
                                            </b-col>
                                            <b-col cols="12" md="6" class="text-left">
                                                <b-button
                                                    variant="primary"
                                                    class="next-btn"
                                                    @click="
                                                        businessPlanToNext(
                                                            data.data,
                                                        )
                                                    "
                                                    >{{
                                                        isLoading
                                                            ? ""
                                                            : "ONBOARD TENANT"
                                                    }}
                                                    <div
                                                        class="spinner-border btn-loader"
                                                        role="status"
                                                        v-if="isLoading"
                                                    >
                                                        <span class="sr-only"
                                                            >Loading...</span
                                                        >
                                                    </div>
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </businessPlanVue>
                            </v-stepper-content>
                            <v-stepper-content step="4">
                                <theme ref="themeRef">
                                    <template v-slot:footer-button="data">
                                        <div class="text-center">
                                            <span
                                                class="text-danger font-weight-bold"
                                                >{{ error }}</span
                                            >
                                        </div>
                                        <b-row
                                            class="mt-4 footer-buttons-row align-items-center justify-content-center"
                                        >
                                            <b-col
                                                cols="12"
                                                md="auto"
                                                class="text-center px-md-1 mb-2 mb-md-0"
                                            >
                                                <b-button
                                                    variant="outline-primary"
                                                    class="cancel-btn"
                                                    @click="
                                                        draftTheme(data.data)
                                                    "
                                                    >DRAFT & QUIT</b-button
                                                >
                                            </b-col>
                                            <b-col
                                                cols="12"
                                                md="auto"
                                                class="text-center px-md-1"
                                            >
                                                <b-button
                                                    variant="primary"
                                                    class="next-btn"
                                                    @click="
                                                        themeToNext(data.data)
                                                    "
                                                    >{{
                                                        isLoading
                                                            ? ""
                                                            : "CONTINUE TO KYC VERIFICATION"
                                                    }}
                                                    <div
                                                        class="spinner-border btn-loader"
                                                        role="status"
                                                        v-if="isLoading"
                                                    >
                                                        <span class="sr-only"
                                                            >Loading...</span
                                                        >
                                                    </div>
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </theme>
                            </v-stepper-content>
                            <v-stepper-content step="5">
                                <s-kyc
                                    class="mt-2"
                                    ref="kycForm"
                                    @readKYC="KYCUpdate($event)"
                                    :documentList="documentList"
                                    :userID="currentTenant"
                                >
                                    <template v-slot:footer-button="data">
                                        <b-row class="mt-4 footer-buttons-row">
                                            <b-col
                                                cols="12"
                                                md="6"
                                                class="text-center mb-2 mb-md-0"
                                            >
                                                <b-button
                                                    variant="outline-primary"
                                                    class="cancel-btn"
                                                    @click="draftKyc(data.data)"
                                                    >DRAFT & APPROVE
                                                    LATER</b-button
                                                >
                                            </b-col>
                                            <b-col cols="12" md="6" class="text-center">
                                                <b-button
                                                    variant="primary"
                                                    class="next-btn"
                                                    @click="
                                                        AgreeToNext(data.data)
                                                    "
                                                    >{{
                                                        isLoading
                                                            ? ""
                                                            : "APPROVE & SEND VERIFICATION MAIL"
                                                    }}
                                                    <div
                                                        class="spinner-border btn-loader"
                                                        role="status"
                                                        v-if="isLoading"
                                                    >
                                                        <span class="sr-only"
                                                            >Loading...</span
                                                        >
                                                    </div>
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </s-kyc>
                            </v-stepper-content>
                            <v-stepper-content step="6">
                                <s-thanks @done="done"></s-thanks>
                            </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </div>
                </b-col>
            </b-row>
        </section>
    </div>
</template>

<script>
import basicInfoVue from "@/components/Tenant/basicInfo.vue";
import businessPlanVue from "@/components/Tenant/businessPlan.vue";
import theme from "@/components/Tenant/theme.vue";
import sAuthentication from "@/components/Tenant/AuthenticationStepper.vue";
import sKYC from "@/components/Tenant/KYC.vue";
import sThanks from "@/components/Tenant/ThankYouStepper.vue";
import { mapActions, mapGetters } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
import { getReverseGeoCode } from "@/services/geocode";
export default {
    name: "CreateTenant",
    components: {
        basicInfoVue,
        businessPlanVue,
        sAuthentication,
        "s-kyc": sKYC,
        theme,
        sThanks,
        ComponentHeader,
    },
    data() {
        return {
            currentTenant: null,
            e1: 0,
            kycChangeObj: {},
            basicInfo: null,
            address: null,
            authentication: null,
            agreement: null,
            documentList: null,
            error: null,
            theme: null,
            isLoading: false,
            basicInfoValid: false,
        };
    },
    computed: {
        ...mapGetters({
            tenantPreferences: "tenant/GetTenantPreferences",
        }),
    },
    methods: {
        ...mapActions({
            getPreference: "tenant/getTenantPreferences",
        }),
        handleBack() {
            this.$router.push("/tenant");
        },
        buildThemePayload(item) {
            return {
                id: this.currentTenant,
                data: {
                    theme: {
                        primaryColor: {
                            gradientType: "",
                            gradientDegree: "",
                            gradientColors: [],
                            color: item.primaryColor,
                        },
                        secondaryColor: {
                            gradientType: "",
                            gradientDegree: "",
                            gradientColors: [],
                            color: item.secondaryColor,
                        },
                        tertiaryColor: {
                            gradientType: "",
                            gradientDegree: "",
                            gradientColors: [],
                            color: item.tertiaryColor,
                        },
                        font: {
                            family: item.fontFamily.text,
                            color: item.fontColor,
                        },
                    },
                },
            };
        },
        async basicInfoToNext(item) {
            const isValid = await this.$refs.basicInfo.isValid();
            if (!isValid) return;

            this.basicInfo = item;
            this.address = item.address;

            await this.updateAddressCoordinates();
            this.e1 = 2;
        },
        async updateAddressCoordinates() {
            const { address } = this;
            if (!address?.location) return;

            const query = `${address.street1},${address.city},${address.state},${address.country}`;

            try {
                const { data } = await getReverseGeoCode(query);
                if (
                    data?.status === "OK" &&
                    data?.results?.[0]?.geometry?.location
                ) {
                    const { lng, lat } = data.results[0].geometry.location;
                    address.location.coordinates = [lng, lat];
                }
                this.error = "";
            } catch {}
        },
        async authenticationToNext(item) {
            const isValid = await this.$refs.authRef.isValid();
            if (!isValid) return;
            this.authentication = item;
            this.error = "";
            this.e1 = 3;
        },
        async createTenantFunc(item) {
            this.error = "";
            this.agreement = item;
            const { basicInfo, address, authentication, agreement } = this;
            const agreementData = agreement.selectMarket
                ? agreement.market.map((obj) => ({
                      categoryType: "MARKET",
                      catalogId: obj._id,
                  }))
                : agreement.catalog.map((obj) => ({
                      categoryType: "DOMAIN",
                      catalogId: obj._id,
                  }));
            this.isLoading = true;
            let agreementPayload = {
                doc: agreement.doc,
                valid: agreement.valid,
                business_plan: {
                    _id: agreement.plan._id,
                    name: agreement.plan.plan_name,
                },
                businessSegmentInfo: agreementData,
            };
            const payload = {
                authentication: {
                    email: authentication.email,
                    userName: authentication.userName,
                    password: authentication.password,
                    phone: authentication.phone,
                },
                name: {
                    first: authentication.firstName,
                    last: authentication.lastName,
                },
                agreement: agreementPayload,
                preferences: {
                    enableManufacturer: item.enableManufacturer
                        ? item.enableManufacturer
                        : false,
                },
                company: {
                    name: basicInfo.name,
                },
                address,
            };
            try {
                let result = await this.$store.dispatch(
                    "tenant/createTenant",
                    payload,
                );
                this.currentTenant = result.response._id;
                let payloadPref = {
                    id: this.currentTenant,
                    data: {
                        paymentMethod: {
                            cod: agreement.paymentOptionKeys.includes("COD"),
                            online: agreement.paymentOptionKeys.includes(
                                "CASHFREE",
                                "PAYTM",
                            ),
                        },
                    },
                };
                await this.$store.dispatch(
                    "tenant/updateTenantPreferences",
                    payloadPref,
                );
                if (agreement.paymentOptionKeys.includes("CASHFREE", "PAYTM")) {
                    let payloadFinalConfig = {
                        id: this.currentTenant,
                        data: {
                            category: "TA",
                        },
                    };
                    if (agreement.paymentOptionKeys.includes("CASHFREE")) {
                        payloadFinalConfig.data.cashfree = {
                            appId: agreement.appkeyCashFree,
                            secretKey: agreement.secretkeyCashFree,
                        };
                    }
                    if (agreement.paymentOptionKeys.includes("PAYTM")) {
                        payloadFinalConfig.data.paytm = {
                            appId: agreement.appkeyPaytm,
                            secretKey: agreement.secretkeyPaytm,
                        };
                    }
                    await this.$store.dispatch(
                        "tenant/setPaymentConfigAction",
                        payloadFinalConfig,
                    );
                }

                this.$swal({
                    title: "Success",
                    text: "Tenant details submitted successfully!",
                    type: "success",
                });
                this.e1 = 4;
            } catch (error) {
                this.$swal({
                    title: "Error",
                    text: "Couldn't create!",
                    type: "error",
                });
            } finally {
                this.isLoading = false;
            }
        },
        async businessPlanToNext(item) {
            const isValid = await this.$refs.businessPlanRef.isValid();
            if (!isValid) return;
            this.$swal({
                title: "Do you want to  create the tenant?",
                text: "Are you sure you want to create this tenant!",
                showCancelButton: true,
                showCloseButton: false,
                focusConfirm: false,
                confirmButtonText: "DISCARD",
                cancelButtonText: "CREATE",
            }).then((result) => {
                if (result.dismiss) {
                    this.createTenantFunc(item);
                } else {
                    this.e1 = 1;
                    return;
                }
            });
        },
        async draftTheme(item) {
            const isValid = await this.$refs.themeRef.isValid();
            if (!isValid) return;
            if (item.primaryColor == "" || item.secondaryColor == "") {
                this.$refs.themeRef.handleValidation();
                return;
            }
            this.theme = item;
            try {
                const payload = {
                    subdomain: item.slug,
                };
                await this.$store
                    .dispatch("tenant/fetchSlugName", payload)
                    .then(async (result) => {
                        if (
                            result.data &&
                            result.data.response &&
                            result.data.response.exists === true
                        ) {
                            this.$toasted.error(
                                "Sub-domain already exist. Try Different!!!",
                            );
                            this.e1 = 4;
                        } else {
                            this.getPreference(this.currentTenant);
                            const payloadPref = this.buildThemePayload(item);
                            const payload = {
                                subdomain: item.slug,
                            };
                            await this.$store.dispatch(
                                "tenant/tenantConfig",
                                payload,
                            );
                            let dataObj = {
                                id: this.currentTenant,
                                data: {
                                    company: {
                                        name: this.basicInfo.name,
                                        logo: item.logo,
                                    },
                                },
                            };
                            await this.$store.dispatch(
                                "tenant/updateTenantById",
                                dataObj,
                            );
                            await this.$store
                                .dispatch(
                                    "tenant/updateTenantPreferences",
                                    payloadPref,
                                )
                                .then((result) => {
                                    this.$swal({
                                        title: "Success",
                                        text: "Theme preferences submitted successfully!",
                                        type: "success",
                                    });
                                    this.$router.push({ path: "/tenant" });
                                })
                                .catch((error) => {
                                    this.$swal({
                                        title: "Error",
                                        text: "Could not update preferences",
                                        type: "error",
                                    });
                                });
                        }
                    });
            } catch (e) {
                this.$swal({
                    title: "Error",
                    text: "Something went wrong!",
                    type: "error",
                });
            }
        },
        async themeToNext(item) {
            const isValid = await this.$refs.themeRef.isValid();
            if (!isValid) return;
            if (!item.primaryColor.length || !item.secondaryColor.length) {
                this.$refs.themeRef.handleValidation();
                return;
            }

            this.isLoading = true;
            this.theme = item;

            try {
                const slugResult = await this.$store.dispatch(
                    "tenant/fetchSlugName",
                    { subdomain: item.slug },
                );

                const slugExists = slugResult?.data?.response?.exists === true;

                if (slugExists) {
                    this.$toasted.error(
                        "Sub-domain already exist. Try Different!!!",
                    );
                    this.e1 = 4;
                    this.isLoading = false;
                    return;
                }

                this.getPreference(this.currentTenant);

                const payloadPref = this.buildThemePayload(item);

                const configPayload = {
                    subdomain: item.slug,
                    tenantId: this.currentTenant,
                };
                await this.$store.dispatch(
                    "tenant/tenantConfig",
                    configPayload,
                );

                const updateTenantPayload = {
                    id: this.currentTenant,
                    data: {
                        company: {
                            name: this.basicInfo.name,
                            logo: item.logo,
                        },
                    },
                };
                await this.$store.dispatch(
                    "tenant/updateTenantById",
                    updateTenantPayload,
                );

                try {
                    await this.$store.dispatch(
                        "tenant/updateTenantPreferences",
                        payloadPref,
                    );
                    this.isLoading = false;
                    this.$swal({
                        title: "Success",
                        text: "Theme preferences submitted successfully!",
                        type: "success",
                    });
                    this.e1 = 5;
                } catch {
                    this.$swal({
                        title: "Error",
                        text: "Could not update preferences",
                        type: "error",
                    });
                    this.isLoading = false;
                }
            } catch (e) {
                this.isLoading = false;
                this.$swal({
                    title: "Error",
                    text: "Something went wrong!",
                    type: "error",
                });
            }
        },
        async AgreeToNext(item) {
            // const isValid = await this.$refs.kycForm.isValid();
            // if (!isValid) return;
            // if (
            //   !this.kycChangeObj.addressProofBack ||
            //   !this.kycChangeObj.addressProofFront ||
            //   !this.kycChangeObj.photoIdFront ||
            //   this.kycChangeObj.photoIdBack
            // ) {
            //   this.$refs.kycForm.handleValidation();
            //   return;
            // }
            this.$swal({
                title: "Do you want to approve KYC?",
                text: "Are you sure you want to Approve the tenant KYC document?",
                showCancelButton: true,
                showCloseButton: false,
                focusConfirm: false,
                confirmButtonText: "CANCEL",
                cancelButtonText: "APPROVE",
            })
                .then((result) => {
                    if (result.dismiss) {
                        this.isLoading = true;
                        this.$refs.kycForm
                            .submitKyc(this.currentTenant, "APPROVED")
                            .then((result) => {
                                this.isLoading = true;
                                this.e1 = 6;
                            })
                            .catch((error) => {
                                this.e1 = 5;
                            });
                    } else {
                        this.e1 = 5;
                    }
                })
                .catch((error) => {});
        },
        async draftKyc() {
            // const isValid = await this.$refs.kycForm.isValid();
            // if (!isValid) return;
            // if (
            //   !this.kycChangeObj.addressProofBack ||
            //   !this.kycChangeObj.addressProofFront ||
            //   !this.kycChangeObj.photoIdFront ||
            //   this.kycChangeObj.photoIdBack
            // ) {
            //   this.$refs.kycForm.handleValidation();
            //   return;
            // }
            this.$refs.kycForm
                .submitKyc(this.currentTenant, "DRAFT")
                .then((result) => {
                    this.e1 = 6;
                })
                .catch((error) => {});
        },
        done() {
            this.$router.push({ path: "/tenant" });
        },
        async setPlace(p) {
            let place = await p;
            let position = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            this.position = position;
        },
        async getKYCList() {
            this.$store
                .dispatch("tenant/fetchKYCListByTenant", this.currentTenant)
                .then((result) => {
                    this.documentList = result.response;
                });
        },
        KYCUpdate(event) {
            this.kycChangeObj = event;
        },
    },
};
</script>

<style scoped>
.card {
    border-width: inherit;
    border-radius: 2px;
    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
    background-color: aliceblue !important;
}

[btn-back="primary"] {
    background-color: var(--primary) !important;
    margin: 0px;
    height: 41px;
    color: white;
}

.img-avatar {
    margin-top: 150px !important;
}
</style>
<style>
.v-stepper {
    box-shadow: none;
}

.v-stepper__header {
    box-shadow: none;
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: flex-start !important;
}

.v-btn:before {
    opacity: -0.12 !important;
}

.v-stepper--alt-labels .v-stepper__step {
    flex-basis: auto !important;
    flex-shrink: 0 !important;
    display: inline-flex !important;
    flex-direction: column !important;
    align-items: center !important;
}

.v-stepper-step-outline {
    border: 1px solid var(--primary) !important;
    height: 0px;
    border-radius: 50%;
    width: 0px;
    margin-top: 8px;
    margin-bottom: 40px;
}

@-moz-document url-prefix() {
    .v-stepper-step-outline {
        padding: 24px 4px 24px 4px;
    }
}

/* Active Tab Class*/
.theme--light.v-stepper .v-stepper__step__step,
.theme--light.v-stepper .v-stepper__step__step .v-icon {
    color: #ffffff;
    background-color: var(--primary) !important;
}

.theme--light.v-stepper {
    background: none !important;
}

.v-stepper--alt-labels .v-stepper__step__step {
    margin-right: 0;
    margin-bottom: 22px;
    margin-top: -21px;
}

.v-stepper__step__step {
    min-height: 42px;
    min-width: 42px !important;
}

.v-stepper__content {
    padding: 0px !important;
    margin-top: 25px;
}

/* Deactive Stepper */
.theme--light.v-stepper
    .v-stepper__step:not(.v-stepper__step--active):not(
        .v-stepper__step--complete
    ):not(.v-stepper__step--error)
    .v-stepper__step__step {
    background: var(--secondary) !important;
}

/* divider between stepper */
.v-stepper--alt-labels .v-stepper__header .v-divider {
    margin: 35px 8px !important;
    -ms-flex-item-align: start;
    align-self: flex-start;
    flex-shrink: 0 !important;
}

/* Footer buttons - responsive layout */
.footer-buttons-row {
    justify-content: center;
}

.footer-buttons-row .cancel-btn,
.footer-buttons-row .next-btn {
    min-width: 180px;
    white-space: normal;
    word-break: break-word;
}

/* Mobile responsive - keep stepper inline */
@media (max-width: 767.98px) {
    .v-stepper__header {
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch !important;
    }

    .v-stepper--alt-labels .v-stepper__step {
        flex-shrink: 0 !important;
    }

    .v-stepper--alt-labels .v-stepper__header .v-divider {
        flex-shrink: 0 !important;
        margin: 35px 4px !important;
    }

    .footer-buttons-row .cancel-btn,
    .footer-buttons-row .next-btn {
        width: 100%;
        max-width: 100%;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
}

@media (max-width: 575.98px) {
    .footer-buttons-row .cancel-btn,
    .footer-buttons-row .next-btn {
        width: 100%;
        max-width: 100%;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
}

.cancel-btn {
    width: 250px;
    height: 37px;
    min-height: 44px;
    color: #3837d6;
    margin-top: 20px;
}

.next-btn {
    width: 260px;
    height: 37px;
    min-height: 44px;
    background-color: #3837d6;
    margin-top: 20px;
}

.swal2-styled.swal2-cancel {
    background-color: #3837d6 !important;
    width: 40%;
}

.swal2-styled.swal2-confirm {
    color: #3837d6 !important;
    background-color: transparent !important;
    border: 1px solid #3837d6 !important;
    width: 40%;
}
</style>
